<template>
	<div>
		<progress-weighing
			:name="localFactors[index].name"
			:complete="complete"
			:disabled="disabled"
			:quantity="rfLength"
			:value="progressValue"
			@on-click="setValuedFactor"
		></progress-weighing>
		<v-layout wrap align-center justify-space-between pt-3>
			<v-flex px-3>
				<card-container header>
					<v-layout wrap pa-4 slot="header">
						<v-flex xs10>
							Valora este Factor:
						</v-flex>
						<v-flex xs2 text-xs-right>
							<countdown :value="timerValue"></countdown>
						</v-flex>
					</v-layout>
					<v-layout wrap align-center pa-5>
						<v-flex xs7 pr-4>
							<v-subheader class="title px-0"
								:style="`color:${$appColors.info} !important`"
							>
								<img
									class="mr-2"
									:src="localFactors[index].urlImage"
									alt=""
								/>
								<span class="ml-2">
									{{ localFactors[index].name }}
								</span>
							</v-subheader>
						</v-flex>
						<v-flex xs5>
							<v-slider
								class="score-slider"
								height="3"
								hide-details
								v-model="score"
								:tick-labels="ticksLabels"
								:max="2"
								step="1"
								:readonly="readonly"
								ticks="always"
								tick-size="5"
								@change="setFactorValue"
							></v-slider>
						</v-flex>
					</v-layout>
				</card-container>
				<card-container footer>
					<v-layout wrap pa-4 slot="header">
						<v-flex xs10>
							Sobre este Factor:
						</v-flex>
					</v-layout>
					<v-layout wrap align-center pa-5 class="pos-relative">
						<v-btn
							fab
							dark
							depressed
							:disabled="leftArrowDisabled"
							small
							color="info" class="arrow-container left"
							:style="`background-color:${$appColors.info} !important`"
							@click="showValuedFactor('left')"
						>
							<v-icon dark size="40">keyboard_arrow_left</v-icon>
						</v-btn>
						<template v-if="localFactors[index].relatedFactorWeights.length > 0 && (indexRelated >= index)">
							<v-flex xs12>
								<v-layout wrap align-center>
									<v-flex xs8 lg9>
										<v-subheader
											class="title px-0"
											:style="`color:${$appColors.info}!important`"
										>
											<img
												class="mr-2"
												:src="localFactors[index].relatedFactorWeights[indexRelated].urlImage"
												alt=""
											/>
											{{ localFactors[index].relatedFactorWeights[indexRelated].name }}
										</v-subheader>
									</v-flex>
									<v-flex xs4 lg2>
										<v-text-field
											class="input-value"
											v-model="localFactors[index].relatedFactorWeights[indexRelated].weight"
											hide-details
											readonly
										></v-text-field>
									</v-flex>
								</v-layout>
							</v-flex>
							<v-btn
								fab
								dark
								depressed
								:disabled="rightArrowDisabled"
								small
								color="info"
								class="arrow-container right"
								@click="showValuedFactor('right')"
							>
								<v-icon dark size="40">keyboard_arrow_right</v-icon>
							</v-btn>
						</template>
					</v-layout>
				</card-container>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
import cardContainer from '@/components/shared/card-container';
import componentWeighing from '@/components/surveys/component-weighing';
import countdown from '@/components/shared/countdown';
import helper from '@/shared/helper';
import progressWeighing from '@/components/surveys/progress-weighing';

const { getLocalData, setLocalData } = helper;

function mounted() {
	if (this.localFactors.every(lf => lf.totalQuestions > 0)) {
		this.readonly = true;
		this.weighingByFactor = getLocalData('weighingByFactor');
		this.score = this.readonly ?
			this.weighingByFactor[this.index].weights[this.progress - 1].factorWeight : 0;
	} else {
		this.setRelatedTotal();
	}
}

function complete() {
	return this.progress === this.rfLength || this.rfLength === 1;
}

function disabled() {
	const disabledEmit = !this.readonly ? this.rfLength !== 1 : false;
	this.$emit('get-disabled', disabledEmit);
	return this.progress !== this.rfLength || this.rfLength === 1;
}

function evaluateArrowsDisabled() {
	this.leftArrowDisabled = this.rfLength === 1 || this.progress === 1;
	this.rightArrowDisabled = this.rfLength === 1 || this.progress === this.rfLength;
}

function progressValue() {
	return (100 / this.rfLength) * this.progress;
}

function setFactorValue() {
	if (!this.readonly) {
		this.weight = this.ticksLabels[this.score];
		this.setRelatedTotal('right', true);
		if (this.timerValue === 100 && !this.rightArrowDisabled) {
			const self = this;
			clearInterval(self.interval);
			this.interval = setInterval(() => {
				if (self.timerValue === 0) {
					self.showValuedFactor('right');
				} else {
					self.timerValue -= 20;
				}
			}, 1000);
		} else {
			this.setLastTotal();
		}
	}
}

function setLastTotal() {
	const lastTotalWeight = this.ticksLabels[this.score] + this.currentTotalWeight;
	const maxValue = lastTotalWeight <= 5 ? lastTotalWeight : 5;
	this.$set(this.localFactors[this.index], 'totalWeight', maxValue);
	this.$set(this.localFactors[this.index], 'totalQuestions', Math.round(maxValue));
}

function setLastTotalOnRelated() {
	const relatedFactorOnRelated = this.localFactors[this.indexRelatedFactor].relatedFactorWeights;
	const indexFactorOnRelated = relatedFactorOnRelated.findIndex(rf =>
		rf.id === this.localFactors[this.index].id
		&& rf.criterionId === this.localFactors[this.index].criterionId);
	this.newRelatedWeight = this.index === 0 ? this.relatedWeight :
		this.localFactors[this.indexRelatedFactor].totalWeight + this.relatedWeight;
	const lastTotalOnRelated = this.ticksLabels[this.score] + this.newRelatedWeight;
	const maxValue = lastTotalOnRelated <= 5 ? lastTotalOnRelated : 5;
	this.$set(this.localFactors[this.indexRelatedFactor], 'totalWeight', maxValue);
	this.$set(
		this.localFactors[this.indexRelatedFactor],
		'totalQuestions',
		Math.round(maxValue));
	this.$set(
		this.localFactors[this.indexRelatedFactor].relatedFactorWeights[indexFactorOnRelated],
		'weight',
		this.ticksLabels[this.score],
	);
}

function setRelatedTotal(direction, edited = false) {
	this.relatedWeight = 1 - this.ticksLabels[this.score];
	const factor = this.localFactors[this.index];
	const relatedFactor = factor.relatedFactorWeights[this.indexRelated];
	this.indexRelatedFactor = this.localFactors.findIndex(lf => lf.id === relatedFactor.id &&
		lf.criterionId === relatedFactor.criterionId);
	if (!this.readonly) {
		if (direction !== 'left') {
			this.$set(relatedFactor, 'weight', this.relatedWeight);
			const newFactor = {
				factorId: factor.id,
				factorName: factor.name,
				factorRelatedId: relatedFactor.id,
				factorRelatedName: relatedFactor.name,
				factorRelatedWeight: this.relatedWeight,
				factorWeight: this.ticksLabels[this.score],
			};
			if (this.weighingByFactor.length === 0) {
				const factorsSelected = {
					id: factor.id,
					name: factor.name,
					weight: 0,
					weights: [],
				};
				factorsSelected.weights.push(newFactor);
				this.$set(this.weighingByFactor, this.index, factorsSelected);
				this.$set(relatedFactor, 'weight', newFactor.factorRelatedWeight);
				this.count += 1;
				this.countReverse += 1;
			} else {
				const weightsFactors = this.weighingByFactor[this.index].weights;
				const updateIndex = weightsFactors.findIndex(wf => wf.factorId === newFactor.factorId
					&& wf.factorRelatedId === newFactor.factorRelatedId);
				const indexToUpdate = updateIndex > -1 ? updateIndex : this.progress - 1;
				if (weightsFactors[indexToUpdate]) {
					this.score = edited ? this.score : this.ticksLabels.findIndex(t =>
						t === weightsFactors[this.indexRelated - this.index].factorWeight);
				}
				newFactor.factorWeight = this.ticksLabels[this.score];
				newFactor.factorRelatedWeight = 1 - this.ticksLabels[this.score];
				this.$set(weightsFactors, indexToUpdate, newFactor);
				this.$set(relatedFactor, 'weight', newFactor.factorRelatedWeight);
				this.count = updateIndex > -1 ? this.count : this.count + 1;
				this.countReverse = updateIndex > -1 ? this.countReverse + 1 : this.count - 1;
			}
		} else {
			this.countReverse -= 1;
			this.score = this.ticksLabels.findIndex(t => t ===
				this.weighingByFactor[this.index].weights[this.indexRelated - this.index].factorWeight);
		}
	}
}

function setTotal() {
	const weighingFactors = this.weighingByFactor[this.index].weights;
	const factorCalculator = weighingFactors.reduce((acum, wf) =>
		acum + wf.factorWeight, 0);
	const totalWeight = factorCalculator;
	const totalQuestions = Math.round(totalWeight);
	this.$set(this.localFactors[this.index], 'totalWeight', totalWeight);
	this.$set(this.localFactors[this.index], 'totalQuestions', totalQuestions);
}

function setTotalOnRelatedFactors() {
	const relatedFactorOnRelated = this.localFactors[this.indexRelatedFactor].relatedFactorWeights;
	const indexFactorOnRelated = relatedFactorOnRelated.findIndex(rf =>
		rf.id === this.localFactors[this.index].id
		&& rf.criterionId === this.localFactors[this.index].criterionId);
	this.newRelatedWeight = this.index === 0 ? this.relatedWeight :
		this.localFactors[this.indexRelatedFactor].totalWeight + this.relatedWeight;
	const maxValue = this.newRelatedWeight <= 5 ? this.newRelatedWeight : 5;
	const relatedQuestions = Math.round(maxValue);
	this.$set(this.localFactors[this.indexRelatedFactor], 'totalWeight', maxValue);
	this.$set(this.localFactors[this.indexRelatedFactor], 'totalQuestions', relatedQuestions);
	this.$set(
		this.localFactors[this.indexRelatedFactor].relatedFactorWeights[indexFactorOnRelated],
		'weight',
		this.ticksLabels[this.score],
	);
}

function setValuedFactor() {
	this.index += 1;
	this.indexRelated = this.index;
	this.rfLength = this.localFactors[this.index].relatedFactorWeights.length - this.index;
	this.progress = 1;
	this.score = this.readonly ?
		this.weighingByFactor[this.index].weights[this.progress - 1].factorWeight : 0;
	this.count = 1;
	this.countReverse = 0;
	if (!this.readonly) {
		this.setWeighingFactor();
	}
	this.evaluateArrowsDisabled();
}

function setWeighingFactor() {
	if (!this.readonly) {
		const factor = this.localFactors[this.index];
		const relatedFactor = factor.relatedFactorWeights[this.indexRelated - this.index];
		const factorsSelected = {
			id: factor.id,
			name: factor.name,
			weights: [],
		};
		const newFactor = {
			factorId: factor.id,
			factorName: factor.name,
			factorRelatedId: relatedFactor.id,
			factorRelatedName: relatedFactor.name,
			factorRelatedWeight: 1 - this.ticksLabels[this.score],
			factorWeight: this.ticksLabels[this.score],
		};
		factorsSelected.weights.push(newFactor);
		this.$set(this.weighingByFactor, this.index, factorsSelected);
	}
}

function showValuedFactor(direction) {
	clearInterval(this.interval);
	this.timerValue = 100;
	this.indexRelated = direction === 'left' ? this.indexRelated - 1 : this.indexRelated + 1;
	this.currentTotalWeight = this.progress === 1 && this.index === 0 ? this.weight :
		this.localFactors[this.index].totalWeight + this.weight;
	if (!this.readonly) {
		this.setTotal();
	}
	this.progress = direction === 'left' ? this.progress - 1 : this.progress + 1;
	this.score = this.readonly ?
		this.weighingByFactor[this.index].weights[this.progress - 1].factorWeight : 0;
	if (!this.readonly) {
		this.setRelatedTotal(direction);
	}
	if (direction !== 'left' && !this.readonly) {
		this.setTotalOnRelatedFactors();
	}
	if ((this.indexRelated - this.index - 2) === this.progress && !this.readonly) {
		this.setLastTotal();
	}
	this.evaluateArrowsDisabled();
}

function weighingWatcher(values) {
	if (values && values.length > 0 && !this.readonly) {
		let v = 0;
		values.forEach((val) => {
			const valWeights = val.weights.filter(vw =>
				vw.factorId === this.localFactors[this.index].id ||
				vw.factorRelatedId === this.localFactors[this.index].id);
			if (valWeights && valWeights.length > 0) {
				if (valWeights.length > 1) {
					v += valWeights.reduce((a, vw) => a + vw.factorWeight, 0);
				} else {
					const valWeightsValue =
						valWeights[0].factorId === this.localFactors[this.index].id ?
							'factorWeight' : 'factorRelatedWeight';
					v += valWeights[0][valWeightsValue];
				}
			}
		});
		const maxValue = v <= 5 ? v : 5;
		this.$set(this.localFactors[this.index], 'totalWeight', maxValue);
		this.$set(this.localFactors[this.index], 'totalQuestions', Math.round(maxValue));
		setLocalData('weighingByFactor', this.weighingByFactor);
	}
}

function data() {
	return {
		count: 0,
		countReverse: -1,
		currentTotalWeight: 0.25,
		index: 0,
		indexRelated: 0,
		indexRelatedFactor: 0,
		interval: {},
		leftArrowDisabled: true,
		newRelatedWeight: 0.75,
		progress: 1,
		readonly: false,
		relatedWeight: 0.75,
		rfLength: 9,
		rightArrowDisabled: false,
		score: 0,
		ticksLabels: [0.25, 0.50, 0.75],
		timerValue: 100,
		weighingByFactor: [],
		weight: 0.25,
	};
}

export default {
	name: 'step-two',
	components: {
		cardContainer,
		componentWeighing,
		countdown,
		progressWeighing,
	},
	computed: {
		complete,
		disabled,
		progressValue,
	},
	data,
	methods: {
		evaluateArrowsDisabled,
		setFactorValue,
		setLastTotal,
		setLastTotalOnRelated,
		setRelatedTotal,
		setTotal,
		setTotalOnRelatedFactors,
		setValuedFactor,
		setWeighingFactor,
		showValuedFactor,
	},
	mounted,
	props: {
		localFactors: {
			default: () => [],
			type: Array,
		},
	},
	watch: {
		weighingByFactor: {
			deep: true,
			handler: weighingWatcher,
		},
	},
};
</script>

<style lang="scss" scoped>
	.pos-relative {
		position: relative;
	}

	.title {
		font-family: map-get($fonts, bold) !important;
	}

	.page-container {
		padding: 0px 55px 0px 22px;
	}

	.input-value {
		margin-left: auto;
	}

	.arrow-container {
		bottom: 0px;
		margin: auto;
		position: absolute;
		top: 0px;

		&.left {
			left: -21px;
		}

		&.right {
			right: -21px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/surveys/step-two.vue